import EcoImg from 'eco-design/base/eco-img';
import { useEffect, useRef } from 'react';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const O: React.FC = () => {
    const { t } = useLang('ats.O');
    const webpOrJpg = useWebpOrJpg('#smart-gateway-O');

    const sectionRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (!sectionRef.current) return;

        const ani1 = AniContainer.create({
            triggerElement: sectionRef.current,
            triggerHook: 1,
            offset: '20%',
            duration: '100%',
            onEnter: () => {
                const title = sectionRef.current?.querySelector('.title');
                const ani2El = sectionRef.current?.querySelector('.ani-2');
                const ani25El = sectionRef.current?.querySelector('.ani-2-5');
                const ani3El = sectionRef.current?.querySelectorAll('.ani-3');
                const ani35El = sectionRef.current?.querySelectorAll('.ani-3-5');
                title?.classList.add('enter');
                console.log(ani2El);
                ani2El?.classList.add('enter');
                ani25El?.classList.add('enter');
                ani3El?.forEach((el) => el.classList.add('enter'));
                ani35El?.forEach((el) => el.classList.add('enter'));
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    const title = sectionRef.current?.querySelector('.title');
                    const ani2El = sectionRef.current?.querySelector('.ani-2');
                    const ani25El = sectionRef.current?.querySelector('.ani-2-5');
                    const ani3El = sectionRef.current?.querySelectorAll('.ani-3');
                    const ani35El = sectionRef.current?.querySelectorAll('.ani-3-5');
                    title?.classList.remove('enter');
                    ani2El?.classList.remove('enter');
                    ani25El?.classList.remove('enter');
                    ani3El?.forEach((el) => el.classList.remove('enter'));
                    ani35El?.forEach((el) => el.classList.remove('enter'));
                }
            },
        });
        return () => {
            ani1.destroy?.();
        };
    }, []);
    return (
        <section
            className={`${css.section} smart-gateway-O GtmModuleData-section`}
            id="smart-gateway-O"
            data-section-id={'smart-gateway-O'}
            data-section-title={t('title')}
            ref={sectionRef}
        >
            <div className="title ani-1">{t('title')}</div>
            <div className="list">
                <div className="item">
                    <EcoImg
                        className="ani-2"
                        pc={webpOrJpg(
                            'https://websiteoss.ecoflow.com/upload/image/1760151603899/%E2%80%9330%E2%84%83%20to%2060%E2%84%83%20Operation%20(1).jpg',
                            'https://websiteoss.ecoflow.com/upload/image/1760151603710/%E2%80%9330%E2%84%83%20(2).webp',
                        )}
                        h5={webpOrJpg(
                            'https://websiteoss.ecoflow.com/upload/image/1760151344093/%E2%80%9330%E2%84%83%20to%2060%E2%84%83%20Operation%20(1).jpg',
                            'https://websiteoss.ecoflow.com/upload/image/1760151353297/%E2%80%9330%E2%84%83%20(1).webp',
                        )}
                    />
                    <div className="item-info">
                        <div className="item-title ani-3">
                            {t.rich('item1_title', {
                                sub: (v: string) => <span className="sub">{v}</span>,
                            })}
                        </div>
                        <div className="item_desc  ani-3">{t('item1_desc')}</div>
                    </div>
                </div>
                <div className="item">
                    <EcoImg
                        className="ani-2-5"
                        pc={webpOrJpg(
                            'https://websiteoss.ecoflow.com/upload/image/1759131595054/O_PC2.jpg',
                            'https://websiteoss.ecoflow.com/upload/image/1759131597089/O_PC2.webp',
                        )}
                        h5={webpOrJpg(
                            'https://websiteoss.ecoflow.com/upload/image/1759131593303/O_M2.jpg',
                            'https://websiteoss.ecoflow.com/upload/image/1759131596465/O_M2.webp',
                        )}
                    />
                    <div className="item-info">
                        <div className="item-title ani-3-5">{t('item2_title')}</div>
                        <div className="item_desc ani-3-5">{t('item2_desc')}</div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default O;
